if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.mainSwiper = null;
        this.thumbnailSwiper = null;
        this._lastFilteredSKU = null;
        this._isInitialLoad = false; // Flag untuk tracking initial load
        this._filterDebounceTimer = null; // Timer untuk debouncing
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        
        // Destroy Swiper instances before clearing content
        this.destroySwiperInstances();
        
        // Reset state
        this._lastFilteredSKU = null;
        this._isInitialLoad = false;
        if (this._filterDebounceTimer) {
          clearTimeout(this._filterDebounceTimer);
          this._filterDebounceTimer = null;
        }
        
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

  show(opener) {
  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  opener.querySelector('.loading__spinner').classList.remove('hidden');

  this._isInitialLoad = true;

  fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const productElement = responseHTML.querySelector('product-info');

      // HAPUS <script> dengan data-main="true"
      const unwantedScripts = productElement.querySelectorAll('script[data-main="true"]');
      unwantedScripts.forEach(script => script.remove());

      this.preprocessHTML(productElement);
      HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

      // Ambil data varian awal
      let initialVariantData = null;
      const scriptElement = productElement.querySelector('script[data-selected-variant]');
      if (scriptElement) {
        try {
          initialVariantData = JSON.parse(scriptElement.textContent);
        } catch (e) {
          console.log('Failed to parse script variant data');
        }
      }

      this.restoreSelectedVariant();
      this.initializeModalSwiper();
      this.initializeVariantFiltering(initialVariantData);

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      super.show(opener);
    })
    .finally(() => {
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      opener.querySelector('.loading__spinner').classList.add('hidden');
    });
}


      // Initialize Swiper instances in the modal
      initializeModalSwiper() {
        console.log('running swiper')
        // Wait a bit for DOM to be fully rendered
        setTimeout(() => {
          this.initThumbnailSwiper();
          this.initMainSwiper();
        }, 200);
      }

      initThumbnailSwiper() {
        if (this.thumbnailSwiper && this.thumbnailSwiper.destroy) {
          this.thumbnailSwiper.destroy(true, true);
        }

        const thumbnailContainer = this.modalContent.querySelector('.thumbnail-swiper');
        if (!thumbnailContainer) return;

        this.thumbnailSwiper = new Swiper(thumbnailContainer, {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          loop: true,
          direction: window.innerWidth >= 1024 ? 'vertical' : 'horizontal',
          breakpoints: {
            320: {
              slidesPerView: 3,
              direction: 'horizontal'
            },
            640: {
              slidesPerView: 4,
              direction: 'horizontal'
            },
            1024: {
              slidesPerView: 4,
              direction: 'vertical'
            }
          }
        });
      }

      initMainSwiper() {
        if (this.mainSwiper && this.mainSwiper.destroy) {
          this.mainSwiper.destroy(true, true);
        }

        const mainContainer = this.modalContent.querySelector('.main-swiper');
        if (!mainContainer) return;

        this.mainSwiper = new Swiper(mainContainer, {
          spaceBetween: 10,
          navigation: {
            nextEl: this.modalContent.querySelector('.swiper-button-next'),
            prevEl: this.modalContent.querySelector('.swiper-button-prev'),
          },
          thumbs: {
            swiper: this.thumbnailSwiper
          },
          lazy: true,
          loop: true,
          grabCursor: true,
          keyboard: {
            enabled: true,
          },
          mousewheel: {
            forceToAxis: true,
          }
        });
      }

      initializeVariantFiltering(initialVariantData = null) {
        const productInfoElement = this.modalContent.querySelector('product-info');
        if (!productInfoElement) return;

        const modalSelf = this;

        // Handle initial filtering dengan delay yang tepat
        let variantData = initialVariantData;
        
        if (!variantData) {
          variantData = extractVariantFromSelections(modalSelf.modalContent);
        }
        
        if (variantData && variantData.sku) {
          modalSelf._lastFilteredSKU = variantData.sku;
          modalSelf.filterSlidesBySKU(variantData.sku);
        }
        
        // Set initial load selesai setelah filtering pertama
        modalSelf._isInitialLoad = false;
        // setTimeout(() => {
        // }, 400); // Delay yang cukup untuk swiper initialization

        // Event listener untuk variant changes
        this.modalContent.addEventListener('change', function(e) {
          if (
            e.target.matches('input[type="radio"]') || 
            e.target.matches('select[name="id"]') || 
            e.target.matches('input[name="id"]') ||
            e.target.matches('select[data-option-position]') ||
            e.target.matches('input[data-option-position]') ||
            e.target.name?.includes('option')
          ) {
            modalSelf.debouncedFilterUpdate();
          }
        });
      }

      // Debounced filter update untuk mencegah multiple calls
      debouncedFilterUpdate() {
        if (this._filterDebounceTimer) {
          clearTimeout(this._filterDebounceTimer);
        }
        
        this._filterDebounceTimer = setTimeout(() => {
          // Skip jika masih dalam initial load
          if (this._isInitialLoad) {
            return;
          }
          
          const variantData = extractVariantFromSelections(this.modalContent);
          
          if (variantData && variantData.sku) {
            // Hanya filter jika SKU berbeda dari yang terakhir
            if (variantData.sku !== this._lastFilteredSKU) {
              this._lastFilteredSKU = variantData.sku; 
              this.filterSlidesBySKU(variantData.sku); 
            }
          }
        }, 150); // Debounce delay
      }

      filterSlidesBySKU(sku) {

        const slidesContainer = this.modalContent.querySelector('.main-swiper');
        const thumbsContainer = this.modalContent.querySelector('.thumbnail-swiper');
        let buttonPrev = this.modalContent.querySelector('.swiper-button-prev')
        let buttonNext = this.modalContent.querySelector('.swiper-button-next')
        
        // Add fade out classes
        slidesContainer?.classList.add('swiper-fade-transition', 'opacity');
        thumbsContainer?.classList.add('swiper-fade-transition', 'opacity');
        buttonPrev?.classList.add('swiper-fade-transition', 'opacity');
        buttonNext?.classList.add('swiper-fade-transition', 'opacity');

        setTimeout(() => {
          const slides = this.modalContent.querySelectorAll('.main-swiper .product__media-item');
          const thumbSlides = this.modalContent.querySelectorAll('.thumbnail-swiper .thumbnail-list__item');

          const normalizedSKU = sku.trim().toLowerCase();

          // Destroy swipers
          if (this.mainSwiper) this.mainSwiper.destroy(true, true);
          if (this.thumbnailSwiper) this.thumbnailSwiper.destroy(true, true);

          // Filter main slides
          slides.forEach((slide) => {
            const alt = slide.getAttribute('data-alt');
            const title = slide.getAttribute('data-product-title');
            const normalizedAlt = alt?.trim().toLowerCase();
            const match = normalizedAlt === normalizedSKU || alt == title;

            slide.style.display = match ? 'block' : 'none';
            slide.classList.toggle('swiper-slide', match);
          });

          // Filter thumbnails
          thumbSlides.forEach((thumb) => {
            const alt = thumb.getAttribute('data-alt');
            const title = thumb.getAttribute('data-product-title');
            const normalizedAlt = alt?.trim().toLowerCase();
            const match = normalizedAlt === normalizedSKU || alt == title;

            thumb.style.display = match ? 'flex' : 'none';
            thumb.classList.toggle('swiper-slide', match);
          });

          // Re-init swipers
          this.initThumbnailSwiper();
          this.initMainSwiper();

          // Fade in setelah delay pendek
          setTimeout(() => {
            slidesContainer?.classList.remove('opacity');
            thumbsContainer?.classList.remove('opacity');
            buttonPrev?.classList.remove('opacity');
            buttonNext?.classList.remove('opacity');
          }, 100);
        }, 200);
      }

      // Destroy Swiper instances
      destroySwiperInstances() {
        if (this.mainSwiper && this.mainSwiper.destroy) {
          this.mainSwiper.destroy(true, true);
          this.mainSwiper = null;
        }
        if (this.thumbnailSwiper && this.thumbnailSwiper.destroy) {
          this.thumbnailSwiper.destroy(true, true);
          this.thumbnailSwiper = null;
        }
      }

      restoreSelectedVariant() {
        // Get product ID from modal content ID
        const modalContentId = this.modalContent.id;
        const productId = modalContentId.replace('QuickAddInfo-', '');
        
        // Find corresponding upsell checkbox
        const upsellCheckboxs = document.querySelectorAll('.upsell-checkbox[data-product-id="' + productId + '"]');
        if (!upsellCheckboxs) return;
        upsellCheckboxs.forEach(upsellCheckbox =>{
        const selectedVariantId = upsellCheckbox.getAttribute('data-variant-id');
        if (!selectedVariantId) return;
          
        // Get stored variant data if available
        const storedVariantData = upsellCheckbox.dataset.variantData;
        
        if (storedVariantData) {
          try {
            const variantData = JSON.parse(storedVariantData);
            this.setVariantByOptions(variantData);
          } catch (e) {
            this.setVariantInModal(selectedVariantId);
          }
        } else {
          this.setVariantInModal(selectedVariantId);
        }
        })
      }

      setVariantByOptions(variantData) {
        const modalContent = this.modalContent;
        const productInfo = modalContent.querySelector('product-info');
        
        if (!productInfo) {
          console.log('Product info not found');
          return;
        }

        // Set options dynamically based on variant data
        const options = [variantData.option1, variantData.option2, variantData.option3];
        
        // Find and set each option using comprehensive selectors
        options.forEach((optionValue, index) => {
          if (!optionValue) return;
          
          const optionIndex = index + 1;
          let optionSet = false;
          
          // Try multiple selector patterns for each option
          const selectors = [
            `input[type="radio"][data-option-position="${optionIndex}"][value="${optionValue}"]`,
            `input[type="radio"][name*="option${optionIndex}"][value="${optionValue}"]`,
            `input[type="radio"][name*="Option${optionIndex}"][value="${optionValue}"]`,
            `.product-form__input:nth-child(${optionIndex}) input[type="radio"][value="${optionValue}"]`,
            `fieldset:nth-of-type(${optionIndex}) input[type="radio"][value="${optionValue}"]`,
            `input[type="radio"][value="${optionValue}"]` // fallback
          ];
          
          // Try radio buttons
          for (const selector of selectors) {
            const radioInput = productInfo.querySelector(selector);
            if (radioInput) {
              radioInput.checked = true;
              radioInput.dispatchEvent(new Event('change', { bubbles: true }));
              optionSet = true;
              break;
            }
          }
          
          // If radio not found, try select dropdowns
          if (!optionSet) {
            const selectSelectors = [
              `select[data-option-position="${optionIndex}"]`,
              `select[name*="option${optionIndex}"]`,
              `select[name*="Option${optionIndex}"]`,
              `.product-form__input:nth-child(${optionIndex}) select`,
              `fieldset:nth-of-type(${optionIndex}) select`
            ];
            
            for (const selector of selectSelectors) {
              const selectInput = productInfo.querySelector(selector);
              if (selectInput) {
                const option = selectInput.querySelector(`option[value="${optionValue}"]`);
                if (option) {
                  selectInput.value = optionValue;
                  selectInput.dispatchEvent(new Event('change', { bubbles: true }));
                  optionSet = true;
                  break;
                }
              }
            }
          }
        });

        // After setting options, wait a bit and then ensure variant ID is set
        setTimeout(() => {
          this.setVariantInModal(variantData.id);
        }, 200);
      }

      setVariantInModal(variantId) {
        const modalContent = this.modalContent;
        
        // Try to set radio button
        const radioInput = modalContent.querySelector('input[type="radio"][value="' + variantId + '"]');
        if (radioInput) {
          radioInput.checked = true;
          // Trigger change event to update other elements
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        
        // Try to set select dropdown
        const selectInput = modalContent.querySelector('select[name="id"]');
        if (selectInput) {
          const option = selectInput.querySelector('option[value="' + variantId + '"]');
          if (option) {
            selectInput.value = variantId;
            // Trigger change event
            selectInput.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
        
        // Try to set hidden input
        const hiddenInput = modalContent.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = variantId;
          // Trigger change event
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        // Try to set in product-info element
        const productInfo = modalContent.querySelector('product-info');
        if (productInfo) {
          // Check radio in product-info
          const productInfoRadio = productInfo.querySelector('input[type="radio"][value="' + variantId + '"]');
          if (productInfoRadio) {
            productInfoRadio.checked = true;
            productInfoRadio.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          
          // Check select in product-info
          const productInfoSelect = productInfo.querySelector('select[name="id"]');
          if (productInfoSelect) {
            const option = productInfoSelect.querySelector('option[value="' + variantId + '"]');
            if (option) {
              productInfoSelect.value = variantId;
              productInfoSelect.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }
          
          // Check hidden input in product-info
          const productInfoHidden = productInfo.querySelector('input[name="id"]');
          if (productInfoHidden) {
            productInfoHidden.value = variantId;
            productInfoHidden.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        this.prepareSwiperElements(productElement);
      }

      // Prepare Swiper elements for initialization
      prepareSwiperElements(productElement) {
        // Ensure swiper containers have proper classes
        const potentialSwipers = productElement.querySelectorAll(
          '.main-swiper, .thumbnail-swiper, [id^="Slider-Gallery"], .product__media-list, .media-gallery'
        );
        
        potentialSwipers.forEach(element => {
          // Add swiper classes if they don't exist
          if (!element.classList.contains('swiper') && !element.classList.contains('swiper-container')) {
            if (element.classList.contains('main-swiper') || element.classList.contains('thumbnail-swiper')) {
              element.classList.add('swiper-container');
            }
          }
          
          // Look for slides wrapper
          const slidesWrapper = element.querySelector('ul, ol, .swiper-wrapper');
          if (slidesWrapper && !slidesWrapper.classList.contains('swiper-wrapper')) {
            slidesWrapper.classList.add('swiper-wrapper');
          }
          
          // Look for individual slides
          const slides = element.querySelectorAll('li, .slide, .swiper-slide, .product__media-item, .thumbnail-list__item');
          slides.forEach(slide => {
            if (!slide.classList.contains('swiper-slide')) {
              slide.classList.add('swiper-slide');
            }
          });
        });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

// Rest of the code remains the same...
document.addEventListener('click', function(e) {
  if (
    e.target.matches('button[data-modal^="QuickAdd-"]')
    && e.target.textContent.trim().includes('Select Option')
  ) {
    const modalId = e.target.getAttribute('data-modal');
    const modal = document.getElementById(modalId);
    if (!modal) return;

    const productId = modalId.replace('QuickAdd-', '');
    const modalContent = modal.querySelector('#QuickAddInfo-' + productId);
    if (!modalContent) {
      return;
    }
    
    const productInfo = modalContent.querySelector('product-info');
    let variantData = null;
    
    if (productInfo) {
      const selectedVariantElement = productInfo.querySelector('[data-selected-variant]');
      if (selectedVariantElement) {
        try {
          variantData = JSON.parse(selectedVariantElement.innerHTML || selectedVariantElement.textContent);
        } catch (e) {
          console.log('Failed to parse selected variant data');
        }
      }
      
      if (!variantData) {
        variantData = extractVariantFromSelections(modalContent);
      }
    }

    if (modal && modal.hide) {
      modal.hide();
    } else {
      modal.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    }
  }
});

function extractVariantFromSelections(modalContent) {
  const productInfo = modalContent.querySelector('product-info');
  if (!productInfo) return null;
  
  let variantData = null;
  
  const selectedVariantElement = productInfo.querySelector('variant-selects [data-selected-variant]');
  if (selectedVariantElement) {
    try {
      const variantText = selectedVariantElement.innerHTML || selectedVariantElement.textContent;
      if (variantText && variantText.trim()) {
        variantData = JSON.parse(variantText);
        return variantData;
      }
    } catch (e) {
      console.log('Failed to parse selected variant data:', e);
    }
  }
  
  let variantId = null;
  let options = [];
  
  const hiddenInput = productInfo.querySelector('input[name="id"]');
  if (hiddenInput) {
    variantId = hiddenInput.value;
  }
  
  if (!variantId) {
    const radioChecked = productInfo.querySelector('input[type="radio"]:checked');
    if (radioChecked) {
      variantId = radioChecked.value;
    }
  }
  
  if (!variantId) {
    const selectElement = productInfo.querySelector('select[name="id"]');
    if (selectElement && selectElement.selectedIndex >= 0) {
      variantId = selectElement.value;
    }
  }
  
  for (let i = 1; i <= 3; i++) {
    let optionValue = null;
    
    const selectors = [
      `input[type="radio"][data-option-position="${i}"]:checked`,
      `select[data-option-position="${i}"]`,
      `input[type="radio"][name*="option${i}"]:checked`,
      `input[type="radio"][name*="Option${i}"]:checked`,
      `select[name*="option${i}"]`,
      `select[name*="Option${i}"]`,
      `.product-form__input:nth-child(${i}) input[type="radio"]:checked`,
      `.product-form__input:nth-child(${i}) select`,
      `fieldset:nth-of-type(${i}) input[type="radio"]:checked`,
      `fieldset:nth-of-type(${i}) select`
    ];
    
    for (const selector of selectors) {
      const element = productInfo.querySelector(selector);
      if (element) {
        if (element.type === 'radio' && element.checked) {
          optionValue = element.value;
          break;
        } else if (element.tagName === 'SELECT' && element.selectedIndex >= 0) {
          optionValue = element.value;
          break;
        }
      }
    }
    
    options.push(optionValue);
  }
  
  if (!variantId) return null;
  
  // Try to get SKU from variant data or product data
  let sku = null;
  const productData = window.product;
  if (productData && productData.variants) {
    const variant = productData.variants.find(v => v.id == variantId);
    if (variant) {
      sku = variant.sku;
    }
  }
  
  variantData = {
    id: variantId,
    sku: sku,
    option1: options[0] || null,
    option2: options[1] || null,
    option3: options[2] || null,
    options: options.filter(Boolean)
  };
  
  return variantData;
}

document.addEventListener('change', function(e) {
  if (e.target.closest('[id^="QuickAddInfo-"]') && 
      (e.target.matches('input[type="radio"]') || 
       e.target.matches('select[name="id"]') || 
       e.target.matches('input[name="id"]') ||
       e.target.matches('select[data-option-position]') ||
       e.target.matches('input[data-option-position]') ||
       e.target.matches('select') ||
       e.target.name?.includes('option'))) {
    
    const modalContent = e.target.closest('[id^="QuickAddInfo-"]');
    const modalContentId = modalContent.id;
    const productId = modalContentId.replace('QuickAddInfo-', '');
    
    setTimeout(() => {
      const variantData = extractVariantFromSelections(modalContent);
      
      if (variantData) {
        const upsellCheckbox = document.querySelector('.product-upsell.desktop .upsell-checkbox[data-product-id="' + productId + '"]');
        const upsellCheckboxMobile = document.querySelector('.product-upsell.mobile .upsell-checkbox[data-product-id="' + productId + '"]')

        if (upsellCheckbox) {
          upsellCheckbox.setAttribute('data-variant-id', variantData.id);
          upsellCheckbox.setAttribute('data-variant-data', JSON.stringify(variantData));
        }
        if (upsellCheckboxMobile) {
          upsellCheckboxMobile.setAttribute('data-variant-id', variantData.id);
          upsellCheckboxMobile.setAttribute('data-variant-data', JSON.stringify(variantData));
        }
      }
    }, 100);
  }
});

document.addEventListener('change', function(e) {
  if (e.target.matches('.upsell-checkbox')) {
    const productId = e.target.getAttribute('data-product-id');
    const variantId = e.target.getAttribute('data-variant-id');
    const variantDataStr = e.target.getAttribute('data-variant-data');
   
    const modal = document.getElementById('QuickAdd-' + productId);
    if (modal && modal.classList.contains('modal--open')) {
      const modalContent = modal.querySelector('#QuickAddInfo-' + productId);
      if (modalContent && variantDataStr) {
        try {
          const variantData = JSON.parse(variantDataStr);
          updateModalVariantSelection(modalContent, variantData);
        } catch (e) {
          if (variantId) {
            updateModalVariantSelectionById(modalContent, variantId);
          }
        }
      }
    }
  }
});

function updateModalVariantSelection(modalContent, variantData) {
  const productInfo = modalContent.querySelector('product-info');
  if (!productInfo) return;

  const options = [variantData.option1, variantData.option2, variantData.option3];
  
  options.forEach((optionValue, index) => {
    if (!optionValue) return;
    
    const optionIndex = index + 1;
    
    const radioInput = productInfo.querySelector(`input[type="radio"][data-option-position="${optionIndex}"][value="${optionValue}"]`);
    if (radioInput) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    
    const selectInput = productInfo.querySelector(`select[data-option-position="${optionIndex}"]`);
    if (selectInput) {
      const option = selectInput.querySelector(`option[value="${optionValue}"]`);
      if (option) {
        selectInput.value = optionValue;
        selectInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
    
    const altRadio = productInfo.querySelector(`input[type="radio"][name*="option${optionIndex}"][value="${optionValue}"]`);
    if (altRadio) {
      altRadio.checked = true;
      altRadio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    
    const altSelect = productInfo.querySelector(`select[name*="option${optionIndex}"]`);
    if (altSelect) {
      const option = altSelect.querySelector(`option[value="${optionValue}"]`);
      if (option) {
        altSelect.value = optionValue;
        altSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  });

  setTimeout(() => {
    updateModalVariantSelectionById(modalContent, variantData.id);
  }, 100);
}

function updateModalVariantSelectionById(modalContent, variantId) {
  const hiddenInput = modalContent.querySelector('input[name="id"]');
  if (hiddenInput) {
    hiddenInput.value = variantId;
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  
  const productInfo = modalContent.querySelector('product-info');
  if (productInfo) {
    const productInfoHidden = productInfo.querySelector('input[name="id"]');
    if (productInfoHidden) {
      productInfoHidden.value = variantId;
      productInfoHidden.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const desktopUpsells = document.querySelectorAll('.product-upsell.desktop input[type="checkbox"]');
  const mobileUpsells = document.querySelectorAll('.product-upsell.mobile input[type="checkbox"]');

  desktopUpsells.forEach((desktopCheckbox, index) => {
    desktopCheckbox.addEventListener('change', function () {
      if (this.checked) {
        mobileUpsells.forEach(mobileCheckbox => mobileCheckbox.checked = false);
      }
    });
  });

  mobileUpsells.forEach((mobileCheckbox, index) => {
    mobileCheckbox.addEventListener('change', function () {
      if (this.checked) {
        desktopUpsells.forEach(desktopCheckbox => desktopCheckbox.checked = false);
      }
    });
  });
});